import RedirectToHome from "components/RedirectToHome";
import { Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Routes as ReactRouterDomRoutes,
  Route,
  useLocation,
} from "react-router-dom";
import Loader from "../components/Loader";
import Layout from "../layout";
import routesConfig from "./routes.config";
import queryString from "query-string";
import { axiosAccount } from "services/api";
import { GENERATE_USER_TEMP_TOKEN } from "helper/url_helper";
import { set } from "services/localStorage";

const Common = route => (
  <Suspense fallback={<Loader />}>
    <route.component />
  </Suspense>
);

const Public = route => {
  const { component: Component } = route;

  return (
    <Suspense fallback={<Loader />}>
      <Component />
    </Suspense>
  );
};

const Private = route => {
  const { component: Component } = route;

  return (
    <Suspense fallback={<Loader />}>
      <Component />
    </Suspense>
  );
};

const createNestedRoutes = (routes, RouteType) => {
  return routes.map((route, i) => {
    if (!route.component) {
      throw new Error("Component must be required....");
    }
    if (route.children) {
      return (
        <Route path={route.path} key={i} element={<RouteType {...route} />}>
          {createNestedRoutes(route.children, RouteType)}
        </Route>
      );
    } else {
      return (
        <Route
          key={i}
          index={route.index}
          path={route.path}
          element={<RouteType {...route} />}
        />
      );
    }
  });
};

const allowedRoutes = ["/", "/login", "/signup"];

const Routes = () => {
  const { isAuth } = useSelector(state => state.Auth);
  const { common, private: privateRoutes, public: publicRoutes } = routesConfig;

  const location = useLocation();

  const pathname = location.pathname;
  const qry = queryString.parse(location.search);
  const redirect_url = qry.redirect_url || qry.redirect_uri;
  const clientId = qry.client_id;

  useEffect(() => {
    if (allowedRoutes.includes(pathname) && redirect_url && clientId) {
      (async () => {
        try {
          const res = await axiosAccount.post(GENERATE_USER_TEMP_TOKEN);
          if (res.status) {
            if (redirect_url.includes("growtogether")) {
              if (res.data?.is_circle_access) {
                let appendWith = "?";
                if (redirect_url.indexOf("?") !== -1) appendWith = "&";
                window.location.replace(
                  `${redirect_url}${appendWith}code=${res.data.temptoken}`
                );
              } else {
                window.location.replace(process.env.REACT_APP_REDIRECT_URL);
              }
            } else {
              let appendWith = "?";
              if (redirect_url.indexOf("?") !== -1) appendWith = "&";
              window.location.replace(
                `${redirect_url}${appendWith}code=${res.data.temptoken}`
              );
            }
          }
        } catch (err) {
          set("redirect_url", redirect_url);
          set("client_id", clientId);
        }
      })();
    }
  }, [clientId, redirect_url, pathname]);

  // if (allowedRoutes.includes(pathname) && redirect_url && clientId) {
  //   return <Loader />;
  // }

  return (
    <ReactRouterDomRoutes>
      {isAuth ? (
        <>
          <Route path="/" element={<Layout />}>
            {createNestedRoutes(privateRoutes, Private)}
          </Route>
          <Route path="/*" element={<RedirectToHome />} />
        </>
      ) : (
        createNestedRoutes(publicRoutes, Public)
      )}
      <>
        <Route path="/" element={<Layout />}>
          {createNestedRoutes(common, Common)}
        </Route>
      </>
    </ReactRouterDomRoutes>
  );
};

export default Routes;
